import { Typography, TypographyProps } from '@mui/material';
import { useEffect, useState } from 'react';

interface TypeTextProps {
  text: string;
  shouldDisableAnimation?: boolean;
  onRenderComplete?: () => void;
  textProps?: TypographyProps;
}

const TYPING_SPEED = 10;

export function TypeText({
  text: fullText,
  shouldDisableAnimation = false,
  onRenderComplete,
  textProps,
}: TypeTextProps) {
  const [text, setText] = useState(shouldDisableAnimation ? fullText : '');

  useEffect(() => {
    if (shouldDisableAnimation) {
      return;
    }

    let timer: ReturnType<typeof setTimeout>;

    const generateText = (index: number) => {
      if (index >= fullText.length) {
        clearInterval(timer);
        return;
      }

      setText((prevText) => prevText + fullText.charAt(index));
      timer = setTimeout(generateText, TYPING_SPEED, index + 1);
    };

    timer = setTimeout(generateText, TYPING_SPEED, 0);

    return () => {
      clearInterval(timer);
    };
  }, [fullText, shouldDisableAnimation]);

  useEffect(() => {
    if (text === fullText) {
      onRenderComplete?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, fullText]);

  return (
    <Typography variant="body1" {...textProps} component="span">
      {text}
    </Typography>
  );
}
